<template>
  <div class="responseDetailMain">
    <div class="cart-title-box">设备信息</div>
    <div class="cart">
      <div class="title">{{ responseDetail.rmk || '-' }}</div>
      <div class="cart-item">
        <div class="before">
          桩编码：
        </div>
        <div class="after">
          {{ responseDetail.deviceNo || '-' }}
        </div>
      </div>
      <div class="cart-item">
        <div class="before">
          端口号：
        </div>
        <div class="after">
          {{ responseDetail.devicePort || "-" }}
        </div>
      </div>

    </div>
    <div class="cart-title-box">用户信息</div>
    <div class="cart">
      <div class="cart-item">
        <div class="before">
          用户名：
        </div>
        <div class="after">
          {{ responseDetail.userName || '-' }}
        </div>
      </div>
      <div class="cart-item">
        <div class="before">
          手机号：
        </div>
        <div class="after">
          {{ responseDetail.mobile || '-' }}
        </div>
      </div>
    </div>
    <div class="cart-title-box">问题反馈</div>
    <div class="cart">
      <div class="cart-item">
        <div class="before">
          问题类型：
        </div>
        <div class="after">
          {{
            responseDetail.type ? responseDetail.type : "其他类型"
          }}
        </div>
      </div>
      <div class="cart-item">
        <div class="before">
          问题描述：
        </div>
        <div class="after">

          {{ responseDetail.rmk || '-' }}
        </div>
      </div>
      <div class="cart-item">
        <div class="before">
          反馈时间：
        </div>
        <div class="after">
          {{ responseDetail.createTime ? formatDate(new Date(responseDetail.createTime),'yyyy-MM-dd hh:mm:ss') : '-' }}
        </div>
      </div>
    </div>
    <div class="cart-title-box">处理信息</div>
    <div class="cart">
      <div class="cart-item">
        <div class="before">
          处理时间：
        </div>
        <div class="after">
          {{ responseDetail.handerTime ? formatDate(new Date(responseDetail.handerTime),'yyyy-MM-dd hh:mm:ss') : '-' }}
        </div>
      </div>
      <div class="cart-item" :class="{'cart-item_state': this.$route.query.state === '待处理'}">
        <div class="before">
          处理批注：
        </div>
        <div class="after" v-if="this.$route.query.state !== '待处理'">
          {{ responseDetail.COMMENT || '-' }}
        </div>
        <div class="after" v-else>
          <el-input
              v-model="form.comment"
              placeholder="填写批注"
              size="normal"
              clearable
              type="textarea"
              :rows="3"
              maxlength="100"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="form-sub-box" v-if="this.$route.query.state === '待处理'">
      <div class="submit-btn" @click="onSubmit()">
        保存
      </div>
    </div>


  </div>
</template>
<script>
import {getFeedBack, doFeedBack} from "@/api/newApi";
import {formatDate} from "@/utils/formart";

export default {
  name: "",
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      responseDetail: {},
      form: {},
    };
  },
  computed: {},
  watch: {},
  mounted() {
    getFeedBack({id: this.$route.query.id}).then((res) => {
      this.responseDetail = res.data;
    });
  },
  methods: {
    formatDate,
    onSubmit() {
      this.form.state = 1;
      this.form.id = this.$route.query.id;
      doFeedBack(this.form).then((res) => {
        if (res.message.code == 0) {
          this.$toast.text("提交成功");
          setTimeout(() => {
            this.$router.push({
              path: "/admin/response",
            });
          }, 800);
        } else {
          this.$toast.text(res.messsage.messsage);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/sass/state.scss";

.responseDetailMain {
  min-height: 100%;
  padding: $divPadding;
  background-color: #F5F5F6;
  .cart-title-box{
    font-size: $fontSize_14;
    padding: 0 $divPadding;
    padding-bottom: $divPadding;
    position: relative;
    &:before {
      content: '';
      position: absolute;
      width: 3px;
      height: 40%;
      border-radius: 2rem;
      left: 0.2rem;
      bottom: 0.3954rem;
      top: 0;
      background-color: #2557FB;
      margin: auto 0;
    }
  }
  .cart {
    background-color: #fff;
    margin-bottom: $divPadding;
    border-radius: $borderRadius;
    padding: $divPadding;
    padding-bottom: 0.38rem;

    .title {
      color: #444444;
      font-size: 0.3783rem;
      padding-bottom: 0.2rem;
    }

    .cart-item_state {
      .before {
        width: 100%;
      }

      .after {
        margin-top: 0.3rem;

        ::v-deep .el-textarea__inner {
          background-color: #F7F7F7;
        }
      }
    }

    .cart-item {
      display: flex;
      flex-wrap: wrap;
      padding-bottom: 0.2rem;
      flex-shrink: 0;
      font-size: 0.3243rem;

      &:last-child {
        padding-bottom: 0;
      }

      .before {
        color: #999999;
      }

      .after {
        color: #666666;
        flex: 1;
        max-width: 100%;
        word-wrap: break-word;
      }

    }

  }
}
</style>
